import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function createFailure(draft: Draft<IProductData>) {
  draft.create.config.isLoading = false;
}

export default createFailure;
